import AbstractValidator from '../abstract-validator';
import AbstractValidatorOptions from '../abstract-validator-options';
import { ga4Push } from '../../../ga4/ga4-utilities';

/**
 * Forgot password form validation module.
 *
 * @author Kovács Tamás
 * @returns Forgot password module
 */
function ForgotPasswordForm() {
    const formId = 'forgotPasswordForm';
    const validator = AbstractValidator(formId);
    const validatorOptions = AbstractValidatorOptions();
    validatorOptions.showToastMessages = false;
    const modal = $('#forgot-password-modal');
    let isSuccess = false;

    function init(
        openModal,
    ) {
        validatorOptions.focusInvalid = false;

        validator.init(
            {
                email: {
                    required: true,
                    customEmail: true,
                },
            },
            validatorOptions,
        );

        $(`#${formId}`)
        .on('success', (event) => {
            ga4Push({
                event: 'forgotten_password',
                newPassword: 'confirm',
            });
            isSuccess = true;
            modal.find('.email-input-wrapper,.send-btn')
            .addClass('d-none').end()
            .find('.success-wrapper,.close-btn')
            .removeClass('d-none');
        });

        modal.parent().one(
            'hidden.bs.modal',
            () => {
                if (!isSuccess) {
                    ga4Push({
                        event: 'forgotten_password',
                        newPassword: 'exit',
                    });
                }
                validator.resetForm();
            },
        );
    }

    return {
        init,
    };
}

export default ForgotPasswordForm;
